import React, {useEffect, useState} from 'react'
import {Container} from 'react-bootstrap';
import {useDispatch, useSelector} from 'react-redux';
import {resetConfirmationDialog, toggleConfirmationDialog, toggleLoader} from '../../shared/actions/setting';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import FeatherIcon from 'feather-icons-react';
import { deleteAccountUser, getAccountUsers } from '../../utils/mainServices';
import FormAccount from './formAccount';
import SearchInput from '../../shared/components/SearchInput';
import useColumnSelector from '../../shared/components/useColumnSelector';

const AccountPageTable = () => {
  const dispatch = useDispatch();
  const [allAccountList, setAllAccountList] = useState([]);
  const {t} = useTranslation();
  const [ deleteAccountId, setDeleteAccountId] = useState(null);
  const [shouldFetchData, setShouldFetchData] = useState(false);
  const [isFormAccountVisible, setIsFormAccountVisible] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null)
  const [searchText, setSearchText] = useState('');
  const { ColumnSelector, columnFilter, columnFilterReadOnly } = useColumnSelector('account-table');

  const confirmationDialog = useSelector(state => {
      return state.setting.confirmationDialog
    });
  

  //Fetch the all Accounts
  useEffect(() => {
    const fetchAccounts = async () => {
      dispatch(toggleLoader(true))
      try {
        const data = await getAccountUsers(); 
        setAllAccountList(data.content);
      } catch (error) {
        console.error('Error fetching Accounts:', error); 
        toast.error("Account can't be fetched");
      } finally {
        dispatch(toggleLoader(false))
      }
    };

    fetchAccounts();
  }, [shouldFetchData]); 

 // Add corporate
  function handleAddAccount() {
    console.log(selectedAccount)
    setIsFormAccountVisible (true)
  }

  //Edit account
  function gotoAccountEdit(account) {
    setSelectedAccount(account)
    setIsFormAccountVisible (true)
  }

  const hideFormAccount = (state) => {
    setIsFormAccountVisible (false)
    setSelectedAccount(null)
    if (state) {
      setShouldFetchData(prev => !prev);
    }
  }

  //delete corporate
  useEffect(() => {
      if (!confirmationDialog || !confirmationDialog.onSuccess || !deleteAccountId) {
        return;
      }
    
      const handleDelete = async () => {
        try {
          dispatch(toggleLoader(true));
          await deleteAccountUser(deleteAccountId);
          toast.success("Account deleted succesfully");
          setShouldFetchData(prev => !prev);
        } catch (error) {
          if (error.response && error.response.status === 422) {
            toast.warn(error.response.data.message);
          } else {
            toast.error("Something went wrong");
          }
        } finally {
          setDeleteAccountId(null);
          dispatch(toggleLoader(false));
          dispatch(resetConfirmationDialog());
        }
      };
    
      handleDelete();
    }, [confirmationDialog, deleteAccountId]);

  function handleDeleteAccount(account) {
    setDeleteAccountId(account.id);
      dispatch(toggleConfirmationDialog({
        isVisible: true,
        confirmationHeading: t("confirmation_msg.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ACCOUNT_WITH_NAME", { name: account.name }),
        confirmationDescription: t("confirmation_msg.THE_DELETE_ACTION_WILL_REMOVE_THE_ACCOUNT_WITH_NAME", { name: account.name })
      }));
    }

  const filteredAccountList = allAccountList.filter(account => {
    const searchLower = searchText.toLowerCase();
    return (
      (account.name && account.name.toLowerCase().includes(searchLower)) ||
      (account.contactName && account.contactName.toLowerCase().includes(searchLower)) ||
      (account.contactPhoneNumber && account.contactPhoneNumber.toLowerCase().includes(searchLower))
    );
  });

  return (
    <div className={"half-list-container"}>
      <Container>
        <div className={"single-card m-rl-m-8 p-a-16"}>
          <div className={"sa-table-flex sa-table-top"}>
            <span className="sa-table-top-left-items">
              <ColumnSelector/>
              <SearchInput
                value={searchText}
                onValueChange={setSearchText}
                placeholder="Search Account"
              />
            </span>
            <div className="sa-table-top-right-items">
              <span>
                <div className="xin-pull-right">
                  <span className="sa-table-icon-flex sa-table-filter-position">
                    <button
                      onClick={handleAddAccount}
                      className={`sa-table-btn-secondary sa-table-btn-secondary-wide sa-table-float-right`}>
                      <FeatherIcon
                        icon={`plus`}
                        className={"sa-table-icon-size"}/> Create Account
                    </button>
                  </span>
                </div>
              </span>
            </div>
          </div>
          <div id="main3" className="sa-table-container xindicate-calc-height">
            <table className="table table-borderless sa-table-width">
              <thead>
              <tr>
                <th hidden={columnFilterReadOnly("No.")} className={"sa-table-head-sticky"}>No.</th>
                <th hidden={columnFilter("Name")} className={"sa-table-head-sticky"}>Name</th>
                <th hidden={columnFilter("Contact Name")} className={"sa-table-head-sticky"}>Contact Name</th>
                <th hidden={columnFilter("Contact Number")} className={"sa-table-head-sticky"}>Contact Number</th>
                <th hidden={columnFilter("Contact Email")} className={"sa-table-head-sticky"}>Contact Email</th>
                <th hidden={columnFilter("Action")} className={"sa-table-head-sticky"}>Action</th>
              </tr>
              </thead>
              <tbody>
              {filteredAccountList.map((account, index) => (
                  <tr key={index}>
                    <td hidden={columnFilterReadOnly("No.")} className={'sa-table-data'}>{index + 1}</td>
                    <td hidden={columnFilter("Name")} className={'sa-table-data'}>{account.name}</td>
                    <td hidden={columnFilter("Contact Name")} className={'sa-table-data'}>{account.contactName}</td>
                    <td hidden={columnFilter("Contact Number")} className={'sa-table-data'}>{account.contactPhoneNumber}</td>
                    <td hidden={columnFilter("Contact Email")} className={'sa-table-data'}>{account.contactEmail}</td>
                    <td hidden={columnFilter("Action")} className={'sa-table-item-align'}>
                      <div className='sa-table-item-flex'>
                        <div className="sa-table-actions sa-action-m" data-toggle="tooltip" title={t("button.EDIT")}>
                          <FeatherIcon
                            onClick={() => gotoAccountEdit(account)}
                            className={`table-action ` }
                            icon={"edit"}
                          />
                        </div>
                        <div className="sa-table-actions sa-action-m" data-toggle="tooltip" title={t("button.DELETE")}>
                          <FeatherIcon
                            className={ 'text-red feather-trash'}
                            icon={`trash-2`}
                            onClick={() => {
                              handleDeleteAccount(account);
                            }}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      {isFormAccountVisible && (<FormAccount 
                                  selectedAccount={selectedAccount} 
                                  onClose={hideFormAccount} 
                                  formType={selectedAccount ? "edit" : "add"} 
                                />
      )}
    </Container>
  </div>
  )
}

export default AccountPageTable;
